export const BADGES = {
    '127': 'Premium Frames',
    '131': 'Clearance',
    '71': 'New',
    LUXURY: 553,
    LUXURY_EXPERIENCE: 610,
    PREMIUM: 127,
    SALE: 131,
};

export const LUXURY_BADGES = [BADGES.LUXURY_EXPERIENCE, BADGES.LUXURY];
